module.exports = __webpack_public_path__ + "static/section-1-img-1@2x-e178cfcb01e3f6fdb3167d8217facec8.png";